export enum AuthErrorEnum {
  Unauthorized = `UNAUTHORIZED`,
  GenericError = `GENERIC_ERROR`,
}

export enum AuthErrorType {
  InvalidGrant = `invalid_grant`,
  BlockedAccount = `blocked_account`,
}
